import React, { useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import { FormTemplate } from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import { FiExternalLink } from "react-icons/fi";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useApprovals } from "../../Vendors/VendorApprovals/useApprovals";
import {
  ApproveRepaymentPlanSetup,
  DeleteRepaymentPlanSetup,
  GetRepaymentPlanSetupById,
  GetSingleOvertime,
} from "../../../../../utils/redux/HR/HRSlice";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import {
  ApproveOvertimeRequest,
  DeclineOvertimeRequest,
  GetAllOvertimeRequisition,
} from "../../../../../utils/redux/HR/HRSlice";
import { PageActions } from "../../../Components/Misc/Actions";
import ApprovalData from "../ApprovalConstants/data";
import { toast } from "react-toastify";

function ViewRepaymentPlanSetup() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { openModal, closeModal } = useApprovals({});
  const [refresh, setRefresh] = React.useState(false);
  const formMethods = useForm({
    mode: "all",
  });
  const { handleSubmit } = formMethods;

  // Fetching the data and isLoading state from Redux state
  const { repayment_plan_setup_by_id, isLoading } = useSelector(
    (state) => state?.hr
  );

  const acq = repayment_plan_setup_by_id?.responseObject;

  // Trigger API to get the Repayment Plan Setup details by ID
  useEffect(() => {
    dispatch(GetRepaymentPlanSetupById(id));
  }, [refresh, dispatch, id]);

  const submit = (e) => {
    console.log(e);
  };

  return (
    <PageLayout title={"Repayment Plan Setup Details"} hasBack={true}>
      <div className={DashboardStyle.app_view_controls}>
        {acq?.approvalStatusEnum === "Pending" && (
          <PageActions>
            {[
              {
                name: "Approve",
                action: () => {
                  openModal({
                    type: "suspend",
                    details: {
                      button: {
                        name: "Yes, Approve",
                        color: "green",
                      },
                      commentIsOptional: true,
                      title: "Approve Repayment Plan Setup",
                      isApprove: "Are you sure you want to approve this setup?",
                      confirmText: "Approve",
                      submitData: (data) => {
                        dispatch(
                          ApproveRepaymentPlanSetup({
                            ruleId: acq?.uuId,
                            comment: "Approved",
                          })
                        )?.then((res) => {
                          if (res?.payload?.successful === true) {
                            closeModal();
                            setRefresh(!refresh);
                            toast.success(res?.payload?.statusMessage);
                          } else if (res?.payload?.successful === false) {
                            toast.error(res?.payload?.statusMessage);
                          }
                        });
                      },
                    },
                  });
                },
              },
              {
                name: "Decline",
                action: () => {
                  openModal({
                    type: "suspend",
                    details: {
                      button: {
                        name: "Decline",
                        color: "red",
                      },
                      isDelete: true,
                      isDeleteSupport:
                        "Are you sure you want to decline this setup?",
                      title: "Decline Repayment Plan Setup",
                      submitData: (data) => {
                        dispatch(
                          DeleteRepaymentPlanSetup({
                            ruleId: acq?.uuId,
                            comment: "Declined",
                          })
                        )?.then((res) => {
                          if (res?.payload?.successful === true) {
                            closeModal();
                            setRefresh(!refresh);
                          } else if (res?.payload?.successful === false) {
                            toast.error(res?.payload?.statusMessage);
                          }
                        });
                      },
                    },
                  });
                },
              },
            ]}
          </PageActions>
        )}
      </div>
      <FormProvider {...formMethods}>
        {isLoading ? ( // Render isLoading spinner if data is being fetched
          <div style={{ textAlign: "center", padding: "20px" }}>
            <span>isLoading...</span>{" "}
            {/* You can replace this with a spinner component */}
          </div>
        ) : (
          <FormTemplate
            className={DashboardStyle.view_app_components}
            handleSubmit={handleSubmit(submit)}
          >
            <section
              style={{
                backgroundColor: "#F8FBF8",
                border: "1px solid #D9E9DA",
                borderRadius: "8px",
              }}
              className={DashboardStyle.form_section}
            >
              <h4 className={DashboardStyle.form_section_title}>
                Repayment Plan Information
              </h4>
              <div className={DashboardStyle.labels_group}>
                <div>
                  <div>
                    <p>Rule ID:</p>
                    <h4>{acq?.id || "-"}</h4> {/* Display Rule ID */}
                  </div>
                  <div>
                    <p>Repayment Plan Type:</p>
                    <h4>{acq?.repaymentPlanType || "-"}</h4>{" "}
                    {/* Repayment Plan Type */}
                  </div>
                  <div>
                    <p>Duration:</p>
                    <h4>{acq?.duration || "-"} month(s)</h4> {/* Duration */}
                  </div>
                  <div>
                    <p>Process Status:</p>
                    <h4
                      style={{
                        color:
                          acq?.approvalStatusEnum === "Approved"
                            ? "green"
                            : acq?.approvalStatusEnum === "Declined"
                            ? "red"
                            : "gray",
                        fontWeight: "bold",
                        backgroundColor:
                          acq?.approvalStatusEnum === "Approved"
                            ? "#ccffcc" // Light green
                            : acq?.approvalStatusEnum === "Declined"
                            ? "#ffcccc" // Light red
                            : "#f0f0f0", // Light gray for other statuses
                        padding: "5px 10px",
                        borderRadius: "4px",
                      }}
                    >
                      {acq?.approvalStatusEnum || ""}
                    </h4>{" "}
                    {/* Display Process Status */}
                  </div>
                </div>
                <div>
                  <div>
                    <p>Title:</p>
                    <h4>{acq?.title || "-"}</h4> {/* Title */}
                  </div>
                </div>
              </div>
            </section>
          </FormTemplate>
        )}
      </FormProvider>
    </PageLayout>
  );
}

export default ViewRepaymentPlanSetup;
